"use strict";
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            SysAppDesigner_OpenPane: "Mobile apps",
            SysAppDesigner_PaneTitle: "{0} Mobile"
        }
    });
    var ax;
    (function (ax) {
        var appDesigner;
        (function (appDesigner) {
            /** Opens the App Designer pane. */
            function open() {
                if (!appDesigner.pane) {
                    appDesigner.pane = {
                        back: appDesigner.close,
                        canGoBack: true,
                        name: "AppDesignerPane",
                        role: "Dialog",
                        templateId: "AppDesignerPane",
                    };
                    $dyn.shell.createForm(appDesigner.pane);
                    var context_1 = $dyn.context(appDesigner.pane.targetElement);
                    context_1.DisplayTarget = $dyn.forms.DisplayTarget.AsidePane;
                    // This is a singleton form, so we do not want to auto close it
                    context_1.PreventAutoClose(true);
                }
                $dyn.shell.open({ form: $dyn.context(appDesigner.pane.targetElement) });
            }
            appDesigner.open = open;
            /** Hides the App Designer pane. */
            function close() {
                if (appDesigner.pane) {
                    $dyn.shell.hideAsidePane(appDesigner.pane.targetElement);
                }
            }
            appDesigner.close = close;
        })(appDesigner = ax.appDesigner || (ax.appDesigner = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=AppDesigner.js.map
